import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Label } from 'semantic-ui-react'
import ReactPDF, { Page, Text, View, Document, StyleSheet, Image, Font, PDFDownloadLink, Svg } from '@react-pdf/renderer';
import { styled } from '@mui/material/styles';
import axios from 'axios';
import { useSelector } from "react-redux";
import './style.css';
import {
  Card,
  Table,
  Button,
  Switch,
  FormControlLabel,
  Checkbox,
  Stack,
  Paper,
  Avatar,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  FormControl,
  TextField
} from '@mui/material';
import { Link } from 'react-router-dom';
import SelectHuntingClub, { components } from 'react-select';
import SelectVrstaClanstva from 'react-select';

export default function Update(props) {
	
	const navigate  = useNavigate();
	
	const [id, setId] = useState(localStorage.getItem('id'));	
	const [subscriberId, setSubscriberId] = useState(localStorage.getItem('subscriberId'));
	const [ime, setIme] = useState('');
	const [tip, setTip] = useState('');
	const [IMEI, setIMEI] = useState('');
	const [tiptrackera, setTiptrackera] = useState('');
	const [brojmobitela, setBrojmobitela] = useState('');
	const [bojaputanje, setBojaputanje] = useState('');
	const [uploadinterval, setUploadinterval] = useState('');
	const [needdisconnect, setNeeddisconnect] = useState('');
	const [needreset, setNeedreset] = useState('');
	const [workmode, setWorkmode] = useState('');
	const [setuploadinterval, setSetuploadinterval] = useState('');
	const [blokiran, setBlokiran] = useState('');
	const [datumstart, setDatumstart] = useState('');
	const [datumendold, setDatumendold] = useState('');
	const [datumendnew, setDatumendnew] = useState('');
	const [datumlast, setDatumlast] = useState('');
	const [brojlokacija, setBrojlokacija] = useState('');

	const [selectedOption, setSelectedOption] = useState(null);
	const [huntingclubs, setHuntingClubs] = useState(null);
	
	const [selectedoptionvrstaclanstva, setSelectedOptionVrstaClanstva] = useState('Aktivni');
	const [vrstaclanstva, setVrstaClanstva] = useState('Aktivni');
	
	const [huntingclubsdataloaded, setHuntingClubsDataLoaded] = useState(null);
	const [selecthuntingclubsdataloaded, setSelectHuntingClubsDataLoaded] = useState(null);
	const [awardtypeId, setAwardTypeId] = useState('1');
	const [options, setOptions] = useState('');
	
	const [checkedlovackilist, setCheckedLovaciList] = useState(true);
	const [checkedclanskupstine, setCheckedClanSkupstine] = useState(false);
	const [checkedgrupovodja, setCheckedGrupovodja] = useState(false);
	
	const { user: currentUser } = useSelector((state) => state.auth);
	
	const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;
	
	var today = new Date();
	
	let day = today.getDate();

	let month = today.getMonth() + 1;

	let year = today.getFullYear();
	
	let hours = today.getHours();
	
	let minutes = today.getMinutes();
	
	let seconds = today.getSeconds();
	
	if (day < 10) {
		day = '0' + day;
	}

	if (month < 10) {
		month = `0${month}`;
	}
	
	if (hours < 10) {
		hours = `0${hours}`;
	}
	
	if (minutes < 10) {
		minutes = `0${minutes}`;
	}
	
	if (seconds < 10) {
		seconds = `0${seconds}`;
	}
	
	const datum = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
	
  function getAccountantfromUser(roles) {
	let result = roles.substring(10, roles.length);
    return result;
  }
	
  const handleChange = (event, id) => {
		
	axios.put("https://gpsdogstracking.com/api/devices/" + id,
		{
		"blokiran": !blokiran
		}
	).then(() => {
		// getAllHunters();
		//objectWithSpecificId.blokiran = !objectWithSpecificId.blokiran;
	});
  };
	
	useEffect(() => {
		setId(localStorage.getItem('id'));
		setIme(localStorage.getItem('ime'));
        setTip(localStorage.getItem('tip'));
        setIMEI(localStorage.getItem('IMEI'));
        setTiptrackera(localStorage.getItem('tiptrackera'));
        setBrojmobitela(localStorage.getItem('brojmobitela'));
        setBojaputanje(localStorage.getItem('bojaputanje'));
	    setUploadinterval(localStorage.getItem('uploadinterval'));
		setNeeddisconnect(localStorage.getItem('needdisconnect'));
		setNeedreset(localStorage.getItem('needreset'));
        setWorkmode(localStorage.getItem('workmode'));
        setSetuploadinterval(localStorage.getItem('setuploadinterval'));
        setBlokiran(localStorage.getItem('blokiran'));
        setDatumstart(localStorage.getItem('datumstart'));
        setDatumendold(localStorage.getItem('datumend'));
		setDatumendnew(localStorage.getItem('datumend'));
	    setDatumlast(localStorage.getItem('datumlast'));
        setBrojlokacija(localStorage.getItem('brojlokacija'));
		
		if (!huntingclubsdataloaded) {
			getHuntingClubsAll();
		}
		
		if (huntingclubsdataloaded && !selecthuntingclubsdataloaded) {
			FillSelectHuntingClubsAll();
		}	
	}, []);
	
	const getHuntingClubsAll = async () => {
      try {
		const response = await axios.get(SERVER_URL + `/huntingclubs/${id}`);
        setHuntingClubs(response.data);
		setHuntingClubsDataLoaded(true);
		console.log(response.data);
      } catch (err) {
        console.log("error");
      }
	};
	
	const FillSelectHuntingClubsAll = async () => {
      try {
		setSelectHuntingClubsDataLoaded(true);
		const clubs = [];
		huntingclubs.map((huntingclub, index) => ( clubs.push({ value: huntingclub.id, label: huntingclub.naziv, icon: huntingclub.flag })));
		console.log(clubs);
		setOptions(clubs);
      } catch (err) {
        console.log("error");
      }
	};

    const handleChangeHuntingClub = e => {
    	setSelectedOption(e);
		console.log(e);
		//setHuntingClubId(e.value);
  	}	

    const handleChangeVrstaClanstva = e => {
    	setSelectedOptionVrstaClanstva(e);
		console.log(e);
		setVrstaClanstva(e.value);
  	}

	const handleChangeCheckLovackiList = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedLovaciList(event.target.checked);
	};
	
	const handleChangeCheckClanSkupstine = (event: React.ChangeEvent<HTMLInputElement>) => {
		setCheckedClanSkupstine(event.target.checked);
	};
	
	const handleChangeCheckGrupovodja = (event: React.ChangeEvent<HTMLInputElement>) => {
		setBlokiran(event.target.checked);
	};
	
	const optionsvrstaclanstva = [
		{ value: "Aktivni", label: "Aktivni", icon: ""},
		{ value: "Pionir", label: "Pionir", icon: ""},
		{ value: "Počasni", label: "Počasni", icon: ""},
	];
		
	const postData = () => {		
		axios.put(SERVER_URL + `/devices/${id}`,
			{
				"ime": ime,
				"IMEI": IMEI,
				"blokiran":blokiran,
				"subscriberId": subscriberId,
				"datumend": datumendnew,
			}
			).then(() => {
			axios.post(SERVER_URL + `/bills`,
			{
				"accountantId": getAccountantfromUser(currentUser.roles[0]),
				"deviceId": id,
				"imei": IMEI,
				"datum": datum,
				"datum_end_old": datumendold,
				"datum_end_new": datumendnew,
				"iznos": 20,
				"booked": 0
			}
			).then(() => {
				//props.handler();
            navigate('/dashboard/DogsReportAll')
			});
        });
		

	}
	
  const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto"
  },
  body: {
    paddingTop: 50,
    paddingBottom: 65,
    paddingHorizontal: 30,
	fontFamily: "Roboto", 
	fontSize: 10,
  },
  title: {
    fontSize: 24,
    textAlign: 'center',
    fontFamily: 'Roboto'
  },
  author: {
    fontSize: 12,
    textAlign: 'center',
    marginBottom: 40,
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    fontFamily: 'Roboto'
  },
  text: {
    margin: 5,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmedium: {
    margin: 3,
    fontSize: 12,
    textAlign: 'justify',
    fontFamily: 'Roboto',
	paddingHorizontal: 20,
  },
  textmediumlarge: {
    margin: 12,
    fontSize: 20,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  textbig: {
    margin: 12,
    fontSize: 28,
    textAlign: 'justify',
    fontFamily: 'Roboto'
  },
  selectimage: {
    margin: 0,
	paddingTop : 0,
	padding : 0,
	height: 40,
	paddingHorizontal: 10,
  },
  selecttext: {
    margin: 3,
    fontSize: 16,
    textAlign: 'justify',
	paddingHorizontal: 20,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'center',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
  officer: {
	paddingTop: 70,
    fontSize: 12,
	margin: 0,
    fontSize: 12,
    fontFamily: 'Roboto',
	left: 150,
  },
  officertext: {
    margin: 0,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
  },
  mp: {
    position: 'absolute',
    fontSize: 12,
    bottom: 100,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey'
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid",  
    borderRightWidth: 0, 
	borderLefttWidth: 0, 
    borderTopWidth: 0,
	borderBottomWidth: 0,
  }, 
  tableRow: { 
    margin: "0", 
    flexDirection: "row",
	 borderWidth: 0,
  }, 
  tableCol: { 
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableColLong: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColShort: { 
    width: "15%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableColVeryShort: { 
    width: "5%", 
    borderStyle: "solid", 
    borderWidth: 0, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  tableCell: { 
    width: "10%", 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
  });
  
  const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
  }));
	
  const customStyles = {
  control: base => ({
    ...base,
	width: 300,
    height: 45,
    minHeight: 25,
	fontSize: 16,
  })
};
  
  const { Option } = components;
  const IconOption = props => (
	<Option {...props}>
	<TableRow style={styles.selectimage}>
	
	<TableCell style={styles.selectimage} align="left">
	
	    <Stack direction="row" alignItems="center" spacing={2}>
		
            <Avatar alt={props.data.label} src={props.data.icon} />
							
			<Typography style={styles.textmedium} variant="subtitle2" noWrap>
				
			</Typography>
			
        </Stack>
						  
	</TableCell>
	
	<TableCell style={styles.selectimage} align="left">
	<Typography style={styles.selecttext} variant="subtitle2" noWrap>
	{props.data.label}
	</Typography>
	</TableCell>
							
	</TableRow>
	</Option>
  );
  
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
		
    return (
		<Container maxWidth="xl">
	    <Typography variant="subtitle2" noWrap>
			Editovanje uređaja
		</Typography>
        <Card>
		  
		    <TableContainer sx={{ minWidth: 100 }}>
			
              <Table>
			  
                <TableBody>
        
                <TableRow>
					<TableCell component="th" scope="row" style={{ width: 80 }} >
						<Label>Subscriber ID</Label>
							<TextField
							required
							defaultValue=""
							value={subscriberId}
							onChange={(e) => setSubscriberId(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "40px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" style={{ width: 80 }} >
						<Label>Ime</Label>
							<TextField
							required
							defaultValue=""
							value={ime}
							onChange={(e) => setIme(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "80px",
							},
							}}
							/>
                    </TableCell>

                    <TableCell component="th" scope="row" style={{ width: 150 }} >
						<Label>Tip</Label>
							<TextField
							required
							defaultValue=""
							value={tip}
							onChange={(e) => setTip(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "150px",
							},
							}}
							/>
                    </TableCell>						
                </TableRow>
				
                <TableRow>	
					<TableCell component="th" scope="row" style={{ width: 150 }} >
						<Label>IMEI</Label>
							<TextField
							required
							defaultValue=""
							value={IMEI}
							onChange={(e) => setIMEI(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "150px"
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" style={{ width: 80 }} >
						<Label>Interval</Label>
							<TextField
							required
							defaultValue=""
							value={uploadinterval}
							onChange={(e) => setUploadinterval(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "20px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" style={{ width: 80 }} >
						<Label>Set Interval</Label>
							<TextField
							required
							defaultValue=""
							value={setuploadinterval}
							onChange={(e) => setSetuploadinterval(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "20px"
							},
							}}
							/>
                    </TableCell>
                </TableRow>
				
                <TableRow>	
					<TableCell component="th" scope="row" style={{ width: 80 }} >
						<Label>Disconnect</Label>
							<TextField
							required
							defaultValue=""
							value={needdisconnect}
							onChange={(e) => setNeeddisconnect(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "20px"
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" style={{ width: 80 }} >
						<Label>Reset</Label>
							<TextField
							required
							defaultValue=""
							value={needreset}
							onChange={(e) => setNeedreset(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "20px",
							},
							}}
							/>
                    </TableCell>
					
					<TableCell component="th" scope="row" style={{ width: 80 }} >
						<Label>Work mode</Label>
							<TextField
							required
							defaultValue=""
							value={workmode}
							onChange={(e) => setWorkmode(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "20px"
							},
							}}
							/>
                    </TableCell>
                </TableRow>
				
                <TableRow>					
					<TableCell component="th" scope="row" style={{ width: 150 }} >
						<Label>Boja putanje</Label>
							<TextField
							required
							defaultValue=""
							value={bojaputanje}
							onChange={(e) => setBojaputanje(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "150px",
							},
							}}
							/>
                    </TableCell>

                    <TableCell component="th" scope="row" style={{ width: 100 }} >
						<Label>Datum End</Label>
							<TextField
							required
							defaultValue=""
							value={datumendnew}
							onChange={(e) => setDatumendnew(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "100px",
							},
							}}
							/>
                    </TableCell>	
				
					<TableCell component="th" scope="row" style={{ width: 150 }} >
						<Label>Broj SIM kartice</Label>
							<TextField
							required
							defaultValue=""
							value={brojmobitela}
							onChange={(e) => setBrojmobitela(e.target.value)}
							inputProps={{
							style: {
							height: "10px",
							width: "150px",
							},
							}}
							/>
                    </TableCell>					
                </TableRow>
                <TableRow>
                    <TableCell component="th" scope="row" >
						<Button onClick={postData} type='submit'>Spasi</Button>
                     </TableCell>			
                </TableRow>
				
                </TableBody>
				
              </Table>
			  
            </TableContainer>
			
        </Card>
        </Container>
    )
}